// extracted by mini-css-extract-plugin
export default {"skillsBlock":"Skills_skillsBlock__6BEdw","skillsContainer":"Skills_skillsContainer__Wd4Bl","title":"Skills_title__+hvqE","skills":"Skills_skills__vs4Jp"};